enum CommandIdEnum {
    AddLengthDimension,
    AddTextAnnotation,
    ProductInfo,
    RemoveFromDocument,
    AddChecklistItem,
    Test,
    Select,
    GeometryMoveEdit,
    GeometryPlanarMove,
    GeometryDirectionalMove,
    GeometryFreeMove,
    GeometryDimensionEndpointMove,
    FocusOnSceneObject,
    FocusOnBimObject,
    AddAreaAnnotation,
    GeometryPolygonEndpointMove,
    ChecklistFreeMove,
    DeleteSceneObject,
    EditProperties,
    AddRectangleAnnotation,
    AddCircleAnnotation,
    ExtrudedLoopAreaSetExtrusionDepth,
    MoveSceneObjects,
    CloneSceneObjects
}

export default CommandIdEnum;